import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';

export default class PortfolioWeight extends Component {


    render() {

        //https://experience.sap.com/fiori-design-web/values-and-names/
        //https://experience.sap.com/fiori-design-web/color-palettes/#qualitative-color-palette


        let symbol_colors = this.props.symbol_colors;
        let data = null;
        let options = {
            legend: false
        }
        if (this.props.positions && this.props.positions.length > 0) {

            data = {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    hoverBackgroundColor: []
                }]
            };
            for (var pos_item of this.props.positions) {

                data.labels.push(pos_item.symbol);
                data.datasets[0].data.push(pos_item.total_invested.toFixed(2));
                data.datasets[0].backgroundColor.push(symbol_colors[pos_item.symbol]);
            }


        }

        return (<div>

            {data &&

                <Doughnut data={data} options={options} />
            }
            {/* <div class="columns">
                <div class="column is-four-fifths">
                    {data &&

                        <Doughnut data={data} options={options} />
                    }
                </div>
                <div class="column">
                    <table class="table">
                        <tbody>
                            {this.props.positions && this.props.positions.length > 0 && this.props.positions.map(function (pos_item, i) {

                                return <tr><i class="fa fa-circle" aria-hidden="true" style={{ "marginRight": "0.75em", color: symbol_colors[pos_item.symbol] }}></i>{pos_item.symbol}</tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </div> */}


        </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portfolio-weight.js